/* ============================================================
   MULTIPLIER QUANTITY – CART DRAWER (mini-cart)

   Loaded globally (not inline in the section), because the
   <mini-cart> drawer body is injected via innerHTML
   (cart-drawer.js / cart.js), and inline <script> tags inserted
   via innerHTML do NOT execute. Document-level event delegation
   registered here survives every drawer re-render.
   ============================================================ */
(function () {
  /* Sections re-rendered after each cart change, mirroring cart-drawer.js /
     cart.js so the drawer body + both cart bubbles update from the
     authoritative server state. */
  const SECTIONS_TO_RENDER = [
    { id: 'mini-cart',               selector: '.shopify-section' },
    { id: 'cart-icon-bubble',        selector: '.shopify-section' },
    { id: 'mobile-cart-icon-bubble', selector: '.shopify-section' }
  ];

  function getSectionInnerHTML(html, selector) {
    const node = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return node ? node.innerHTML : null;
  }

  function updateCartLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: SECTIONS_TO_RENDER.map(s => s.id),
        sections_url: window.location.pathname
      })
    }).then(res => {
      if (!res.ok) {
        return res.text().then(body => {
          throw new Error('cart/change.js ' + res.status + ': ' + body);
        });
      }
      return res.json();
    });
  }

  function refreshSections(sections) {
    if (!sections) return;
    SECTIONS_TO_RENDER.forEach(({ id, selector }) => {
      const target = document.getElementById(id);
      if (!target || !sections[id]) return;
      const inner = getSectionInnerHTML(sections[id], selector);
      if (inner !== null) target.innerHTML = inner;
    });
  }

  /* Resolve the multiplier line's hidden updates[] input by its line index, since
     it lives outside .drawer-qty-row (sibling of .drawer-qty-inline). */
  function getHiddenQty(line) {
    return document.querySelector('.cart-hidden-qty[data-index="' + line + '"]');
  }

  function applyStep(row, baseQty) {
    const multiplier = parseInt(row.dataset.multiplier || '1', 10);
    const line = parseInt(row.dataset.line, 10);
    if (!Number.isInteger(line) || line < 1) {
      console.error('mini-cart multiplier: invalid line index', row.dataset.line);
      return;
    }
    const baseInput = row.querySelector('.qty-input');
    const cleanBase = Math.max(1, parseInt(baseQty, 10) || 1);

    baseInput.value = cleanBase;

    const finalQty = cleanBase * multiplier;
    const hiddenQty = getHiddenQty(line);
    if (hiddenQty) hiddenQty.value = finalQty;

    updateCartLine(line, finalQty)
      .then(data => refreshSections(data.sections))
      .catch(console.error);
  }

  /* + / - buttons */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.drawer-qty-row .qty-btn');
    if (!btn) return;

    const row = btn.closest('.drawer-qty-row');
    if (!row) return;

    const multiplier = parseInt(row.dataset.multiplier || '1', 10);
    if (multiplier <= 1) return; // normal products untouched

    // Stop the click here so no theme handler (cart-items / quantity-input) reacts.
    e.preventDefault();
    e.stopPropagation();

    const baseInput = row.querySelector('.qty-input');
    let baseQty = parseInt(baseInput.value || '1', 10);

    if (btn.dataset.action === 'increase') {
      baseQty += 1;
    } else {
      baseQty = Math.max(1, baseQty - 1);
    }

    applyStep(row, baseQty);
  });

  /* Manual typing */
  document.addEventListener('change', function (e) {
    const baseInput = e.target.closest('.drawer-qty-row .qty-input');
    if (!baseInput) return;

    const row = baseInput.closest('.drawer-qty-row');
    if (!row) return;

    const multiplier = parseInt(row.dataset.multiplier || '1', 10);
    if (multiplier <= 1) return;

    // Prevent this change from bubbling to <cart-items> (which would POST the raw
    // base value against an undefined line index).
    e.stopPropagation();

    applyStep(row, parseInt(baseInput.value || '1', 10));
  }, true);
})();
